// O2 Union Signals: wire types mirroring the backend signal-queue DTOs (camelCase).

export type SignalCategory = 'DoesntWorkHere' | 'DoesntLiveHere' | 'MissingMember' | 'RecruitmentLead'

export type SignalResolution = 'EmploymentEnded' | 'ConfirmedMoved' | 'ContactInfoApplied' | 'Dismissed'

export interface SignalItem {
  sessionId: string
  contactId: string
  contactName: string
  contactAddress: string | null
  contactPhone: string | null
  contactEmail: string | null
  sessionDate: string
  turfLabel: string
  worksiteId: string | null
  worksiteLabel: string | null
  resultStatus: string
  memberAnswer: 'Yes' | 'No' | 'NotSure' | null
  offListPhone: string | null
  offListEmail: string | null
  offListContext: string | null
  notes: string | null
  canEndEmployment: boolean
}

export interface SignalQueuePage {
  category: SignalCategory
  items: SignalItem[]
  totalCount: number
  page: number
  pageSize: number
}

/** Open-signal counts per category on the campaign stats payload; null on the campaign tier. */
export interface UnionSignalCounts {
  doesntWorkHere: number
  doesntLiveHere: number
  missingMember: number
  recruitmentLead: number
}

/** Shared section headings: used by the queue page groups and the dashboard card rows. */
export const SIGNAL_HEADINGS: Record<SignalCategory, string> = {
  DoesntWorkHere: "Doesn't work here",
  DoesntLiveHere: "Doesn't live here",
  MissingMember: 'Missing from the system',
  RecruitmentLead: 'Recruitment leads',
}
